import { View, view } from "@spawn/core";
import { NrgWinPartyView as CoreNrgWinPartyView } from "@spawn/nrg-games-core";
import { MariachiWinSoundView } from "./mariachiWinSoundView";

@view
export class NrgWinPartyView extends CoreNrgWinPartyView {
	protected override createExtraViews(): View[] {
		return [new MariachiWinSoundView()];
	}
}
